export const midTruncate = (value = "", maxLength = 12): string => {
  if (!value) return value
  if (value.length <= maxLength) return value

  const nearcomPrefix = "nearcom:"
  if (value.toLowerCase().startsWith(nearcomPrefix)) {
    if (maxLength <= nearcomPrefix.length) {
      return nearcomPrefix.slice(0, Math.max(0, maxLength))
    }
    const suffix = value.slice(nearcomPrefix.length)
    const suffixMaxLength = Math.max(1, maxLength - nearcomPrefix.length)
    return `${nearcomPrefix}${midTruncate(suffix, suffixMaxLength)}`
  }
  const charsToShow = maxLength - 3
  const frontChars = Math.ceil(charsToShow / 2)
  const backChars = Math.floor(charsToShow / 2)

  return `${value.substring(0, frontChars)}…${value.substring(
    value.length - backChars
  )}`
}

export function chainNameToNetworkName(chainName: string): string {
  switch (chainName) {
    case "eth":
      return "ethereum"
    case "xrpledger":
      return "XRP Ledger"
    case "bsc":
      return "BNB Smart Chain"
    default:
      return chainName
  }
}
